export default __webpack_public_path__ + "static/media/verticle-right.c2b78fe1.svg";